
























import {buildRequestHeader} from "@/shared/services/helper/utils";

function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

import {Component, Emit, Model, Prop, PropSync, Watch} from "vue-property-decorator";
import RotateImage from "@/shared/components/RotateImage/index.vue";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
@Component({
    name: "UploadImageLading",
    components: {RotateImage}
})
export default class extends mixins(CommonMixin) {
    @Prop({ default: '126', type: String})
    readonly width!: string;
    @Prop({ default: '126', type: String })
    readonly height!: string;
    @Prop({ default: "avatar", type: String })
    readonly folder!: string;
    @Prop({ default: "avatar", type: String })
    readonly type!: string;
    @Prop({default: 2, type: Number})
    readonly limit!: number;

    @Prop({default: (path: string) => `${process.env.VUE_APP_BASE_URL}upload/${path}`, type: Function})
    readonly pathToUrl!: (path: string) => string;

    @PropSync("imageUrl", { type: String, default: "" })
    syncImageUrl!: string;

    @Model("change")
    images!: string;

    handleChange(changed) {
        const {fileList, file} = changed;
        this.fileList = fileList;
        if (['done', 'removed'].includes(file.status)) {
            this.emitChange(changed);
        }
    }

    @Emit("change")
    emitChange({fileList}){
        const result = fileList.map((file: any) => file.url ? file.name : file.response?.data?.path)
            ?.join(',');
        return result;
    }

    @Watch("images", {immediate: true})
    onImagesChange(val: string) {
        const value = val ? val.split(',').map((item, index) => ({
            uid: (-index).toString(),
            name: item,
            status: 'done',
            url: this.pathToUrl?.(item) ?? item
        })) : [];
        this.fileList = value;
    }

    fileList: any[] = [];
    headers = buildRequestHeader(false as any);
    params = {
        folder: this.folder
    };
    action = `${process.env.VUE_APP_BASE_API}v1/upload/by-file`;

    onClearImage() {
        this.emitChange({fileList: []})
    }
}
